import { isNullOrUndefined } from "util";

export interface IAddress {
    line1?: string;
    line2?: string;
    zip_code?: string;
    city?: string;
    country?: string;
    countryCode?: string;
    iris_code?: string;
    lat?: number
    lng?: number
    isNotEmpty?: () => boolean
}


export class AddressDto implements IAddress {
    line1?: string;
    line2?: string;
    zip_code?: string;
    city?: string;
    country?: string
    countryCode?: string
    iris_code?: string
    lat?: number
    lng?: number

    constructor(opts?: IAddress){
        if(opts !== undefined) Object.assign(this,opts)
    }

    isNotEmpty():boolean{
        const res= (this.line1 || this.country || this.city || this.zip_code)
        return res !== ''&& !isNullOrUndefined(res)
    }
}


// WEBPACK FOOTER //
// ./src/models/address/address.model.ts